<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="textilemodelcategory3_keyno" [ttModel]="edit.textilemodelcategory3_keyno" ttReadonly></tt-input>
        <tt-input *ngIf="textileModelCategory3Keyno === '0'" ttLabel="textilemodelcategory3lang_name" [(ttModel)]="edit.textilemodelcategory3lang_name" ttRequired></tt-input>
        <tt-input *ngIf="textileModelCategory3Keyno !== '0'" ttLabel="textilemodelcategory3lang_name" [(ttModel)]="edit.textilemodelcategory3lang_name" [ttButtons]="languageNameButtons" ttRequired></tt-input>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
